export const hasKeyInfo = (description: string) => {
  description?.split("\n\n").length > 1;
};

export const extrudeKeyInfo = (description: string | null | undefined) => {
  if (typeof description === "string") {
    const descriptionChunks = description?.split("\n\n");
    return descriptionChunks.length > 1
      ? description?.split("\n\n")[description?.split("\n\n").length - 1]
      : "";
  }
  return "";
};

export const extrudeAdditionalInfo = (description: string | null | undefined) => {
  if (typeof description === "string") {
    return description.split("\n\n")[0];
  }
  return "";
};
